$(window).on('load', function () {

    $('#spinner').hide();
})

jQuery(function ($) {
    $('h1,h2,h3,h4,h5,h6,li,p').each(function () {
        if ($(this).text().split(" ").length > 4 && window.innerWidth > 450) {
            $(this).html($(this).html()
                .replace(/\s([^\s<]+)\s*$/, '&nbsp;$1')
                .replace(/ &amp;/, '&nbsp;&amp;'));
        }
    });
});

$(document).ready(function () {
    //Carousel for partners list
    $('.splide').each(function () {
        var splide = new Splide(this, {
            type: 'loop',
            perPage: 6,
            arrows: false,
            gap: '50px',
            autoplay: $(this).data('autoplay'),
            speed: 1000,
            drag: true,
            pauseOnHover: true,
            pauseOnFocus: true,
            pagination: false,
            breakpoints: {
                1100: {
                    perPage: 4,
                }, 800: {
                    perPage: 3,
                }, 500: {
                    perPage: 2,
                },
            }
        });
        splide.mount();
    });


    $('.elements__imagegriditem').each(function () {
        $(this).wrap('<li class="splide__slide"></li>')
    })
    $('.element-grid.splide').each(function () {

        var splide = new Splide(this, {
            type: 'loop',
            perPage: $(this).data('listelement-count'),
            arrows: false,
            gap: '50px',
            autoplay: false,
            drag: false,
            speed: 0,
            pauseOnHover: true,
            pauseOnFocus: true,
            pagination: false,
            breakpoints: {
                1100: {
                    drag: true, autoplay: true, perPage: 1, speed: 2000
                },
            }
        });
        splide.mount();
    });

    //Add Superscript to all header and link instances of FECPAKG2, PhenR and RATA
    $('label, a, span, h2').each(function () {
        if ($(this).html() == 'FECPAKG2') $(this).html('FECPAK<sup>G2</sup>')
        if ($(this).html() == 'PhenR') $(this).html('Phen<sup>R</sup>')
        if ($(this).html() == 'RATA') $(this).html('RĀTĀ')
    })

    //Remove preload class after page load to allow transitions
    $("body").removeClass("preload");

    // Navigation
    $('#menu-toggle').on('click', function () {
        var $body = $('body'), $menu = $('.nav-container'), $hamburger = $('.hamburger');
        $body.toggleClass('menu-open')
        if ($body.hasClass('menu-open')) {
            $menu.addClass('menu-active');
            $hamburger.addClass('is-active');
        } else {
            $menu.removeClass('menu-active');
            $hamburger.removeClass('is-active');
        }
    });

    $('.cookie-window-close').on('click', function (event) {
        event.preventDefault()
        $('.cookie-consent-holder').remove()
    })

    $('input[name="action_submitConsent"]').val("Save preferences")

    // Nav
    $('.nav .toggler').on('click', function (e) {
        e.preventDefault();
        let $this = $(this).closest('.nav-item');

        //TODO: Close sections already open?
        /*$('.nav-container .nav-item.has-children').each(function() {
            if($this !== $(this))
                $(this).removeClass('.show-children');
        })*/
        $this.toggleClass('show-children');

        let $subNav = $this.find('.secondary');
        if ($this.hasClass('show-children')) {
            $subNav.removeClass('with-transition');
            $subNav.height('auto');
            let ht = $subNav.height();
            $subNav.height(0);
            $subNav.addClass('with-transition');
            $subNav.height(ht);
        } else {
            $subNav.height(0);
        }
    });

    // Map Code
    $('.leaflet-map').each(function () {
        makeMap($(this));
    })

    const locale = getCookie('locale');
    if (locale) {
        // Set the select option based on the cookie value
        $('#locale').val(locale);
    }

    if ($('.glide-galleries-container').length) {
        $('.glide-galleries-container').each(function () {
            makeGlideCarousel($(this));
            watchSecondaryImageList($(this));
        });
    }
});

function watchSecondaryImageList($glide) {
    let $glide1 = $glide.children('.glide.main-gallery-container');
    let $bulletList = $glide1.children('.bullet-nav');
    let $bulletItems = $bulletList.children('.bullet');
    let $glide2 = $glide.children('.secondary-gallery-container');
    let $ImageList2 = $glide2.children('.image-gallery').children('.gallery-slides');
    let $imgItems = $ImageList2.children('.img-item');

    $($imgItems).each(function () {
        $(this).on('click', function () {
            let $imgPos = $(this).data('img-pos') - 1;

            $($bulletItems).each(function () {
                if ($(this).data('pos') === $imgPos) {
                    $(this).trigger('click');
                }
            });
        });
    });
}
function makeGlideCarousel($glide) {
    let $glide1 = $glide.children('.glide.main-gallery-container');
    // let $glide2 = $glide.children('.glide.secondary-gallery-container');
    let $glideID = $glide1.attr('id');
    // let $glideID2 = $glide2.attr('id');
    let $glideEle = $(`#${$glideID}`)[0];
    // let $glideEle2 = $(`#${$glideID2}`)[0];

    let $targetCog = $glide.parent();

    let $mainGlide = new Glide($glideEle, {
        type: "carousel",
        dragThreshold: true,
        perView: 1,
    });

    // Mount both instances
    window.setTimeout(function () {
        $mainGlide.mount();
        // $secondaryGlide.mount();
    }, 1000)

    // Update both Glides for image resizing + take away loading cog
    window.setTimeout(function () {
        $mainGlide.update();
        // $secondaryGlide.update();

        if ($targetCog.hasClass('inactive')) {
            $targetCog.removeClass('inactive');
        }
    }, 1250)
}

var map;
var $iconImgArray = [
    '/_resources/themes/techion/images/marker-0.svg',
    '/_resources/themes/techion/images/marker-1.svg',
    '/_resources/themes/techion/images/marker-2.svg',
    '/_resources/themes/techion/images/marker-3.svg',
    '/_resources/themes/techion/images/marker-4.svg',
    '/_resources/themes/techion/images/marker-5.svg',
    '/_resources/themes/techion/images/marker-6.svg',
    '/_resources/themes/techion/images/marker-7.svg',
];

function makeMap($map) {
    let $data = $map.data('info');
    let $result;
    let $filtered = false, $locationList = [], $groupArray = [];
    let $mapID = $map.attr('id');
    let $locationsSection = $map.parent().children('.locations-section');
    let map;

    var $iconArray = {
        'tech-blue': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-0.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'fec-blue': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-1.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'light-blue': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-2.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'deep-blue': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-3.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'spot-yellow': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-4.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'burnt-yellow': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-5.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'pink': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-6.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'purple': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-7.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'orange': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-8.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
        'green': L.icon({
            iconUrl: '/_resources/themes/techion/images/marker-9.svg',

            iconSize: [38, 38], // size of the icon
            iconAnchor: [19, 38], // point of the icon which will correspond to marker's location
            popupAnchor: [0, -35] // point from which the popup should open relative to the iconAnchor
        }),
    };

    $.ajax({
        url: '/ajax/getLocations',
        method: 'POST',
        data: {$data},
        async: false,
        dataType: 'json',
        success: function ($data) {
            $result = JSON.parse(JSON.stringify($data));
        }
    });

    if (Object.keys($result).length === 1) {
        $.each($result, function (i, val) {
            map = L.map($mapID).setView([val['lat'], val['long']], 13)
        });
    } else {
        map = L.map($mapID);

        $.each($result, function (i, val) {
            $.each(val['groups'], function (i, val) {
                if (!isInArray(val, $groupArray)) {
                    $groupArray.push(val);
                }
            });
        });
    }

    var myFeatureGroup = L.featureGroup().addTo(map).on('click', flyOver);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 19, attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);

    // let $southWest = L.latLng(-52.02545860348813, 158.0712890625),
    //     $northEast = L.latLng(-30.939924331023455, 189.44824218750003);
    //
    // let $bounds = L.latLngBounds($southWest, $northEast);
    //
    // map.setMaxBounds($bounds);
    // map.setMinZoom(5);

    let markers = myFeatureGroup;

    // Add markers
    $map.on('initialize', function () {
        var maxLat, minLat, maxLng, minLng;
        //Clear old markers
        markers.clearLayers();

        let $visibleLocations = $locationsSection.children('.locations-list').children('.location-link:visible');
        let counter = 0;
        $visibleLocations.each(function () {
            if(!$(this).children().data('lat') || !$(this).children().data('long') ) return
            if ($(this).attr('href') !== '') {
                L.marker([$(this).children().data('lat'), $(this).children().data('long')], {icon: $iconArray[$(this).data('marker')]})
                    .bindPopup('<span class="sub-heading">' + $(this).find('.text .location-title h3').html() + '</span><br>'
                        + '<a target="_blank" href="' + $(this).attr('href') + '">Click here to learn more.' + '</a>')
                    .addTo(markers);
            } else {
                L.marker([$(this).children().data('lat'), $(this).children().data('long')], {icon: $iconArray[$(this).data('marker')]})
                    .bindPopup('<span class="sub-heading">' + $(this).find('.text .location-title h3').html() + '</span>')
                    .addTo(markers);
            }
            //Keep track of min/max lat/lng
            if (!maxLat || $(this).children().data('lat') > maxLat) maxLat = $(this).children().data('lat');
            if (!minLat || $(this).children().data('lat') < minLat) minLat = $(this).children().data('lat');
            if (!maxLng || $(this).children().data('long') > maxLng) maxLng = $(this).children().data('long');
            if (!minLng || $(this).children().data('long') < minLng) minLng = $(this).children().data('long');
        });

        if(!maxLat) return

        //Set bounding box
        map.fitBounds([[maxLat, maxLng], [minLat, minLng]])
        //Make sure it's not too zoomed in
        if (map.getZoom() > 6) {
            map.setZoom(6);
        }
    }).trigger('initialize');

    map.on('dragend', function () {
        let $updateOnMove = $map.children('.updateOnMove').children('input').is(':checked');

        if ($filtered === false && $updateOnMove) {
            moveEnd($locationList)
        }

        $filtered = false;
    });

    map.on('zoomend', function () {
        let $updateOnMove = $map.children('.updateOnMove').children('input').is(':checked');

        if ($filtered === false && $updateOnMove) {
            moveEnd($locationList)
        }

        $filtered = false;
    });

    let $groupFilters = $locationsSection.find('.filter-item')

    function filterUpdate() {
        let groupsChecked = $groupFilters.find('.group-filter:checked'),
            list = $locationsSection.find('.location-link');
        $locationList = [];

        if (groupsChecked.length === 0) {
            $(list).show();
            list.each(function () {
                $locationList.push($(this))
            });
        } else {
            $(list).hide();
            groupsChecked.each(function () {
                let group = $(this).attr('value').replaceAll(' ', '-').toLowerCase();

                if ($(this).attr('value') === 'All') {
                    $(list).show();
                    list.each(function () {
                        $locationList.push($(this))
                    });
                    return;
                }

                list.each(function () {
                    if (isInArray(group, $(this).data('custom-type').split(' '))) {
                        $(this).show();
                        $locationList.push($(this))
                    }
                });
            });
        }

        $map.trigger('initialize');
        $filtered = true;

        setTimeout(function () {
            $filtered = false;
        }, 1500);
    }


    function moveEnd($result) {
        let $currBounds = map.getBounds(), $hideList = [],
            $keepList = []
        let $list = $locationsSection.find('.location-link');

        $currBounds = {
            'x1': $currBounds['_northEast']['lng'],
            'x2': $currBounds['_southWest']['lng'],
            'y1': $currBounds['_northEast']['lat'],
            'y2': $currBounds['_southWest']['lat'],
        }

        $.each($result, function (i, val) {
            let $title = val.data('title');
            if (val.children('.location').data('lat') < $currBounds['y1'] && val.children('.location').data('lat') > $currBounds['y2']
                && val.children('.location').data('long') < $currBounds['x1'] && val.children('.location').data('long') > $currBounds['x2']) {

                $.each($list, function () {
                    if ($title === $(this).data('title')) {
                        $keepList.push($(this)[0])
                        return false;
                    }
                });
            } else {
                $.each($list, function () {
                    if ($title === $(this).data('title')) {
                        $hideList.push($(this)[0])
                        return false;
                    }
                });
            }
        });

        $($keepList).show();
        $($hideList).hide();
    }

    function flyOver(event) {
        map.flyTo([event.layer.getLatLng().lat, event.layer.getLatLng().lng], 13);
    }


    // $('.updateOnMove input').change(function () {
    $map.find('.updateOnMove input').change(function () {
        let $locations = [];

        if (!$(this).is(':checked')) {
            $.each($locationList, function (i, val) {
                $locations.push(val[0])
            });
        }

        $($locations).show()
    });
    // filterUpdate();
    // Filter providers by region
    $groupFilters.find('.group-filter').change(function () {
        filterUpdate();
    }).filter(':checked').trigger('change')
}

$('.location-link:visible').on('click', function (e) {
    if ($(this).attr('href') === '') {
        e.preventDefault();
    }
});

function isInArray(element, array) {
    return array.includes(element);
}

$('.resource-video').click(function (event) {
    let clicked = $(this).attr('id');
    $('#modal-' + clicked).addClass('show');
    $('body').addClass('no-scroll');
});

$('.modal .close').click(function () {
    $('body').removeClass('no-scroll');
    $(this).parent().parent().removeClass('show');
})

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
}

function setCookie(name, value, days) {
    const date = new Date();
    date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
    const expires = "expires=" + date.toUTCString();
    document.cookie = `${name}=${value}; ${expires}; path=/`;
}

$('#btnUpdateRegion').on('click', function() {
    let locale = $('#locale').val();
    setCookie('locale', locale, 30);
    location.href = '/' + locale;
});

$('#closeLocaleBanner').on('click', function () {
    $('#localeBanner').hide();
    setCookie('hideLocaleBanner', true, 1);
});
